import { createApi } from '@reduxjs/toolkit/query/react';
import { createCustomFetchBaseQuery } from '../baseQuery';

export const levelsApi = createApi({
  reducerPath: 'levels',
  baseQuery: createCustomFetchBaseQuery,
  tagTypes: ['levles'],
  endpoints: (builder) => ({
    getAllLevelQuestions: builder.query({
      query: ({ page = 1, limit = 10, status = 'active', keyword = '', gameName }) => ({
        url: '/level-questions/levels',
        method: 'GET',
        params: { page, limit, status, keyword, gameName },
      }),
      transformResponse: (response) => ({
        data: response.data,
        meta: response.meta,
      }),
      providesTags: ['levels'],
    }),
  }),
});
export const { useGetAllLevelQuestionsQuery } = levelsApi;
